<template>
  <el-container class="layout">
    <el-header class="layout__header">
      <header-component />
    </el-header>

    <el-container class="layout__body">
      <el-aside class="layout__aside" :width="asideWidth">
        <sidebar-component :is-collapse="isCollapse" @toggle-collapse="toggleCollapse" />
      </el-aside>

      <el-main class="layout__main">
        <div class="main-content-wrapper">
          <router-view />
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import HeaderComponent from './Header.vue'
import SidebarComponent from './Sidebar.vue'
import { ref, computed, onMounted } from 'vue'

export default {
  name: 'LayoutContainer',
  components: { HeaderComponent, SidebarComponent },
  setup() {
    // 折叠状态持久化，刷新后保持用户习惯
    const isCollapse = ref(localStorage.getItem('sidebarCollapsed') === 'true')

    const toggleCollapse = () => {
      isCollapse.value = !isCollapse.value
      localStorage.setItem('sidebarCollapsed', String(isCollapse.value))
    }

    const asideWidth = computed(() => (isCollapse.value ? '64px' : '224px'))

    onMounted(() => {
      // 窄屏默认折叠，保证内容区可用宽度
      if (window.innerWidth < 1440 && localStorage.getItem('sidebarCollapsed') === null) {
        isCollapse.value = true
      }
    })

    return { isCollapse, toggleCollapse, asideWidth }
  }
}
</script>

<style scoped>
.layout {
  height: 100vh;
  overflow: hidden;
}

.layout__header {
  height: 56px;
  flex: 0 0 56px;
  padding: 0;
}

.layout__body {
  flex: 1;
  min-height: 0;
}

.layout__aside {
  background: var(--bg-card);
  border-right: 1px solid var(--border);
  overflow: hidden;
  transition: width var(--dur-base) var(--ease);
}

.layout__main {
  padding: 20px 24px 32px;
  background: var(--bg-page);
  overflow-y: auto;
}

/* 只做宽度约束，不再整体套白色卡片，
   由各页面自行使用卡片组织内容 */
.main-content-wrapper {
  width: 100%;
  max-width: 1560px;
  margin: 0 auto;
}

@media (max-width: 1180px) {
  .layout__main {
    padding: 16px;
  }
}
</style>
